import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, SubContainer } from '../../../components/Container';
import { Button } from '../../../components/Button';
import { CTA, Transaction } from '../styles';
import { Card } from '../../../components/Card';
import Title from '../../../components/Title';
import { ModalContext } from '../../../context/ModalContext';
import { AutomaticoRequest } from '../../../context/AutomaticoContext';


const PixAutomatico = (): JSX.Element => {
    const history = useNavigate();
    const modal = useContext(ModalContext);
    const [horaLimite, setHoraLimite] = useState("");

    const [multiConta, setMultiConta] = useState(false);
    const [valor, setValor] = useState("");
    const [iniciadoPor, setIniciadoPor] = useState("");
    const [frequencia, setFrequencia] = useState("");
    const [recebedor, setRecebedor] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [primeiroPagamento, setPrimeiroPagamento] = useState("");

    const [dataInicio, setDataInicio] = useState("");
    const [dataEncerramento, setDataEncerramento] = useState("");
    const [ocorrencias, setOcorrencias] = useState(0);
    const [descricao, setDescricao] = useState("");
    const [formaPagamento, setFormaPagamento] = useState("");
    const [limiteAutorizacao, setLimiteAutorizacao] = useState("");
    const [id, setId] = useState("");

    const [pagamentoImediado, setPagamentoImediato] = useState({
        date: "",
        amount: "",
        remittanceInformation: "",
    });
    const [aceitaTentativas, setAceitaTentativas] = useState(false);

    let contextAutomatico = useContext(AutomaticoRequest);

    const cancel = () => {
        let cancelModal: any = modal;
        cancelModal.update("CANCEL-AUTOMATIC", { text: `Você será redirecionado de volta para ${iniciadoPor}. Nenhuma transação será realizada.`});
    };

    const confirm = () => {        
        let confirmModal: any = modal;
        confirmModal.update("AUTOMATIC", { text: `Você será redirecionado de volta para ${iniciadoPor}. As transferências serão realizadas conforme os agendamentos definidos na instituição iniciadora.`});
    };

    useEffect(() => {
        if (!contextAutomatico.hasData) {
            history("/");
        }

        const dadosAutomatico = contextAutomatico.dados;
        setHoraLimite(dadosAutomatico.horaLimite);
        setValor(dadosAutomatico.amount);
        setIniciadoPor(dadosAutomatico.initiatorBy);
        setFrequencia(dadosAutomatico.frequency);
        setPrimeiroPagamento(dadosAutomatico.firstPaymentDate);
        setRecebedor(dadosAutomatico.creditor.name);
        setCpfCnpj(dadosAutomatico.creditor.document);

        setDataInicio(dadosAutomatico.schedule.startDate);
        setDataEncerramento(dadosAutomatico.schedule.endDate);
        setOcorrencias(dadosAutomatico.schedule.quantity);
        setDescricao(dadosAutomatico.schedule.paymentDescription);
        setId(dadosAutomatico.schedule.contractId);
        setFormaPagamento(dadosAutomatico.schedule.paymentType);
        setLimiteAutorizacao(dadosAutomatico.schedule.maximumVariableAmount);

        setPagamentoImediato(dadosAutomatico.firstPayment);
        setAceitaTentativas(dadosAutomatico.isRetryAccepted);
    }, [contextAutomatico, history]);

    return (
        <Container>
            <SubContainer>
                <Title title="Confirmação">
                    <p>
                    A confirmação corresponde a criação do Pix automático e à efetivação do primeiro pagamento. 
                    Você tem até {horaLimite} para confirmar esta transação.
                    </p>
                </Title>

                <Transaction>
                    <div>
                        <Card style={{minHeight: multiConta ? "376px" : ""}}>
                            <div className="card-wrapper">
                                <div className="card-body-line">
                                    <div>
                                        <h3 className="transaction-title">Pix automático</h3>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Para</span>
                                            <span className="transaction-info">{recebedor}</span>
                                        </div>
                                        { valor && (
                                            <div className="transaction-info-area">
                                                <span className="transaction-info-title">Valor</span>
                                                <span className="transaction-info">{valor}</span>
                                            </div>
                                        )}
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Iniciado por</span>
                                            <span className="transaction-info">{iniciadoPor}</span>
                                        </div>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Frequência</span>
                                            <span className="transaction-info">{frequencia}</span>
                                        </div>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Primeiro pagamento em</span>
                                            <span className="transaction-info">{primeiroPagamento}</span>
                                        </div>
                                    </div>

                                    <div>
                                        <h3 className="transaction-title">Recebedor</h3>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Nome</span>
                                            <span className="transaction-info">{recebedor}</span>
                                        </div>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">CNPJ</span>
                                            <span className="transaction-info">{cpfCnpj}</span>
                                        </div>
                                    </div>
 
                                    <div>
                                        <h3 className="transaction-title">Dados do agendamento</h3>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Começa em</span>
                                            <span className="transaction-info">{dataInicio}</span>
                                        </div>
                                        {
                                            dataEncerramento &&
                                                <div className="transaction-info-area">
                                                    <span className="transaction-info-title">Encerra em</span>
                                                    <span className="transaction-info">{dataEncerramento}</span>
                                                </div>
                                        }
                                        {
                                            ocorrencias && 
                                                <div className="transaction-info-area">
                                                    <span className="transaction-info-title">Número de ocorrências</span>
                                                    <span className="transaction-info">{ocorrencias}</span>
                                                </div>
                                        }
                                        {
                                            descricao &&
                                                <div className="transaction-info-area">
                                                    <span className="transaction-info-title">Descrição do pagamento</span>
                                                    <span className="transaction-info">{descricao}</span>
                                                </div>
                                        }
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Forma de pagamento</span>
                                            <span className="transaction-info">{formaPagamento}</span>
                                        </div>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">ID da cobrança</span>
                                            <span className="transaction-info">{id}</span>
                                        </div>
                                        <div className="transaction-info-area">
                                            <span className="transaction-info-title">Limite da autorização</span>
                                            <span className="transaction-info">{limiteAutorizacao}</span>
                                        </div>
                                    </div>

                                    {
                                        pagamentoImediado && (
                                            <div>
                                                <h3 className="transaction-title">Pagamento imediato</h3>
                                                <div className="transaction-info-area">
                                                    <span className="transaction-info-title">Valor</span>
                                                    <span className="transaction-info">{pagamentoImediado.amount}</span>
                                                </div>
                                                <div className="transaction-info-area">
                                                    <span className="transaction-info-title">Data do pagamento</span>
                                                    <span className="transaction-info">{pagamentoImediado.date}</span>
                                                </div>
                                                {
                                                    pagamentoImediado.remittanceInformation && 
                                                        <div className="transaction-info-area">
                                                            <span className="transaction-info-title">Descrição do pagamento</span>
                                                            <span className="transaction-info">{pagamentoImediado.remittanceInformation}</span>
                                                        </div>
                                                }
                                            </div>                                 
                                        )
                                    }
                                </div>
                            </div>
                        </Card>
                        <div className='info-transaction'>
                            <p> Para que as transações sejam efetivadas, você deve ter saldo disponível nas datas previstas para o pagamento. Você pode cancelá-los até um dia antes. </p>
                            { aceitaTentativas &&
                                <>
                                    <p> Caso não seja possível efetivar o pagamento na data de cobrança, esta autorização prevê tentativas de pagamentos após a data de vencimento. </p>
                                    <p> Pagamentos realizados após a data agendada da cobrança podem resultar em juros e multas, acrescidos ao pagamento seguinte. </p> 
                                </>
                            }
                        </div> 
                    </div>                     
                </Transaction>                

                <CTA>
                    <Button className="full" value="Confirmar" onClick={confirm} />
                    <Button className="secondary full" value="Cancelar" onClick={cancel} />
                </CTA>
            </SubContainer>
        </Container>
    );
};

export default PixAutomatico;